import { JetSmartEvent } from "./JetSmartEvent";
import { Subscription } from "./Subscription";

export class EventBus {
    private events: JetSmartEvent[] = new Array<JetSmartEvent>();
    private subscriptions: Subscription[] = new Array<Subscription>();

    public raiseEvent(event: JetSmartEvent): void {
        this.events.push(event);

        // For testing purposes
        // tslint:disable:no-console
        // console.log("Raise event", event.name);
        // console.log(event.params);
        // tslint:enable:no-console

        this.subscriptions.forEach((subscription) => subscription.callback(event));
    }

    public subscribe(subscription: Subscription): void {
        this.subscriptions.push(subscription);
        this.events.forEach((event) => subscription.callback(event));
    }

    public unsubscribe(name: string): void {
        this.subscriptions = this.subscriptions.filter((item) => item.name !== name);
    }
}
